import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-056eafc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "menu_opener" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  class: "menu opened",
  key: "opened"
}
const _hoisted_5 = {
  class: "menu closed",
  key: "closed"
}
const _hoisted_6 = { id: "menu_container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://docs.fithor.net/" }, "Fithor")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://reviewnote.kamusoft.jp/ja/" }, "復習帳")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "http://color.kamusoft.jp/" }, "色しらべ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://github.com/muak" }, "ライブラリ")
], -1))
const _hoisted_11 = {
  key: 0,
  class: "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      id: "global_header",
      style: _normalizeStyle({zIndex:_ctx.state.zIndex})
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.shared.isTop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h1", null, [
                _createVNode(_component_router_link, {
                  class: "logo",
                  to: "/"
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                class: "logo",
                to: "/"
              })
            ])),
        _createElementVNode("button", {
          id: "menu_opener_button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.menuToggle && _ctx.menuToggle(...args)))
        }, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.state.menuIsOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : (_openBlock(), _createElementBlock("div", _hoisted_5))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("nav", _hoisted_6, [
          _createElementVNode("ul", null, [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/about" }, {
                default: _withCtx(() => [
                  _createTextVNode("開発者について")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ], 4),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_Transition, {
        name: "modal",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_ctx.state.menuIsOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ], 64))
}